import React, { useContext, useCallback, useEffect } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { WizardPage, wizardProps } from 'gw-portals-wizard-react';
import { useDependencies } from 'gw-portals-dependency-react';
import { useAuthentication } from 'gw-digital-auth-react';
import { QuestionSetComponent } from 'gw-components-platform-react';
import { useValidation } from 'gw-portals-validation-react';
// eslint-disable-next-line import/no-unresolved
import config from 'app-config';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import metadata from './QualificationPage.metadata.json5';
import styles from './../../quoteandbind-common-styles.module.scss';
import { TranslatorContext } from '@jutro/locale';
import { Chevron, ModalNextProvider } from '@jutro/components';
import { messages as commonMessages } from 'gw-platform-translations';
import messages from './QualificationPage.messages';

const LOB_PATH = {
    PersonalAuto: 'lobData.personalAuto.preQualQuestionSets.children[0].value',
    Homeowners: 'lobData.homeowners.preQualQuestionSets.children[0].value',
    HOPHomeowners: 'lobData.homeowners.preQualQuestionSets.children[0].value',
    BusinessOwners: 'lobData.businessOwners.preQualQuestionSets.children[0].value',
    BusinessAuto: 'lobData.businessAuto.preQualQuestionSets.children[0].value',
    BP7BusinessOwners: 'lobData.farm.preQualQuestionSets.children[0].value',
    Farm: 'lobData.farm.preQualQuestionSets.children[0].value'
};

const POLICY_LINE_PATH = {
    PersonalAuto: 'baseData.preQualQuestionSets.children[0].value',
    Homeowners: 'baseData.preQualQuestionSets.children[0].value',
    HOPHomeowners: 'baseData.preQualQuestionSets.children[0].value',
    BusinessOwners: 'baseData.preQualQuestionSets.children[0].value',
    BusinessAuto: 'baseData.preQualQuestionSets.children[0].value',
    BP7BusinessOwners: 'baseData.preQualQuestionSets.children[0].value',
    Farm: 'baseData.preQualQuestionSets.children[0].value'
};

const LINE_SPECIFIC_PATH = {
    PersonalAuto: 'lobData.personalAuto.coverables.vehicles.children',
    BusinessAuto: 'lobData.businessAuto.coverables.vehicles.children',
    HOPHomeowners: 'lobData.homeowners.allCoverables.children',
    BusinessOwners: 'lobData.businessOwners.coverables.locations.children',
    BP7BusinessOwners: 'lobData.homeowners.allCoverables.children',
    Farm: 'lobData.homeowners.allCoverables.children'
};

const dateQuestionKeysHO = ['HOP_GenSigPol02_EY', 'HOP_GenSigPol05_EY'];

function QualificationPage(props) {
    const breakpoint = useContext(BreakpointTrackerContext);
    const translator = useContext(TranslatorContext);
    const { wizardData: submissionVM, updateWizardData, underwritingIssues, filterUWIssuesInCustomOffering } = props;
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const { authHeader } = useAuthentication();
    const {
        registerInitialComponentValidation,
        isComponentValid,
        initialValidation,
        onValidate
    } = useValidation('QualificationPage');
    const lobCode = _.get(submissionVM.value, 'baseData.productCode');
    const BLOCKS_QUOTES = ['BlocksQuote', 'BlocksQuoteRelease'];
    const BLOCKS_BIND = 'BlocksBind';
    const NON_BLOCKING = 'NonBlocking';

    const updateDateQuestionsHO = (answerSet) => {
        dateQuestionKeysHO.forEach((key) => {
            var answerDate = answerSet[key];
            if (answerDate) {
                submissionVM.lobData.homeowners.preQualQuestionSets.value[0].answers[key] = new Date(answerDate.year, answerDate.month, answerDate.day).toLocaleDateString();
            }
        });

    };

    const parseDateObjects = (answerSet) => {
        dateQuestionKeysHO.forEach((key) => {
            if (answerSet[key]) {
                var answerDate = new Date(answerSet[key]);
                var parsedDate = {
                    day: answerDate.getDate(),
                    month: answerDate.getMonth(),
                    year: answerDate.getFullYear()
                };
                submissionVM.lobData.homeowners.preQualQuestionSets.value[0].answers[key] = parsedDate;
            }

        });
    };


    const onNext = useCallback(async () => {
       // _.unset(submissionVM.value, 'bindData');
        if (submissionVM.lobData.homeowners.value) {
            const newQualQuestionSets = _.get(submissionVM, LOB_PATH[lobCode]);
         //   updateDateQuestionsHO(submissionVM.lobData.homeowners.preQualQuestionSets.value[0].answers);
            if(newQualQuestionSets) {
                updateDateQuestionsHO(newQualQuestionSets.answers);
            }
        }
        submissionVM.value = await LoadSaveService.generateSigningPackageDetails(
            submissionVM.value,
            authHeader
        );

        const isBlocksBind = submissionVM.errorsAndWarnings.underwritingIssues.value && submissionVM.errorsAndWarnings.underwritingIssues.value.some((offeringIssue) => {
            return offeringIssue.currentBlockingPoint === BLOCKS_BIND;            
        });

          // if(isBlocksBind || (submissionVM.errorsAndWarnings.validationIssues.issues.value && submissionVM.errorsAndWarnings.validationIssues.issues.value.length > 0)){
        //     if(isBlocksBind){
        //     ModalNextProvider.showAlert({
        //         title: 'Warning',
        //         message: translator(messages.modalWarning),
        //         status: 'warning',
        //         icon: 'mi-warning-outline',
        //         confirmButtonText: commonMessages.ok
        //     }).catch(_.noop);
        //     return false;
        // }
        
        return submissionVM;
    }, [submissionVM, LoadSaveService, authHeader]);


    const resolveVisibility = (lob) => {
        if (lob === 'PersonalAuto' || lob === 'BusinessAuto' || lob === 'HOPHomeowners') {
            return true;
        }
        return false;
    };


    const resolvePolicyLineVisibility = (lob) => {
        if (lob === 'BusinessOwners' || lobCode === 'BP7BusinessOwners') {
            return true;
        }
        return false;
    };


    function generateAutoHeaderOverride() {
        const dataPath = _.get(submissionVM, LINE_SPECIFIC_PATH[lobCode]);
        const overrides = dataPath.map((item, index) => {
            return {
                [`vehicleQuestionSets${index}`] : {
                    title: item.displayName.value
                }
            };
        });
        return Object.assign({}, ...overrides);
    }

    const getHeaderSection = (title, title1) => {
        return (
            <React.Fragment>
                <h3 className={`${styles.title} ${styles.gwOverrideDefaultMargin}`}>{title}</h3>
                <div className={styles.row}>
                    <div>
                        <h3 className="wizardTitle">{title1}</h3>
                    </div>
                </div>
            </React.Fragment>
        );
    };


    const generateHOHeaderOverride = useCallback(() => {
        const offerings = _.get(submissionVM, 'lobData.homeowners.offerings.value');
        const coverages = offerings.flatMap((offering) => offering.coverages.dwellingCoverages.map(dwe => dwe));
        const overrides = coverages.map((dwe, index) => {
            const title1 = 'Location # ' + dwe.dwellingLocation;
            const title2 = 'Package: ' + dwe.dwelingName;

            return {
                [`vehicleQuestionSets${index}`] : {
                    subtitle: getHeaderSection(title1, title2)
                }
            };
        });
        return Object.assign({}, ...overrides);

    }, []);

    const getOverrides = () => {
        if (lobCode === 'HOPHomeowners') {
            return generateHOHeaderOverride();

        } else if (lobCode === 'BusinessAuto') {
            return generateAutoHeaderOverride();
        }
    };

    const findBlockingPoint = (type) => {
        return underwritingIssues.some((offeringIssue) => {
            if (type === BLOCKS_BIND) {
                return offeringIssue.currentBlockingPoint === BLOCKS_BIND;
            }
            return _.includes(BLOCKS_QUOTES, offeringIssue.currentBlockingPoint);
        });
    }



    const overrideProps = {
        '@field': {
            // apply to all fields
            showOptional: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        questionSets: {
            path: LOB_PATH[lobCode],
            visible: resolveVisibility(lobCode)
        },
        farmOrBopQuestionSets:{
            path: POLICY_LINE_PATH[lobCode],
            visible: resolvePolicyLineVisibility(lobCode),
            subtitle: (<hr></hr>),          
        },
        ...getOverrides(),
        vehicleQuestionSetContainer: {
            path: LINE_SPECIFIC_PATH[lobCode],
            visible: false // lobCode === 'BusinessAuto'
        },
        underWritingIssues: {
            underwritingIssues: underwritingIssues,
            blockQuote: findBlockingPoint(),
            quoteID: submissionVM.quoteID.value,
            filterUWIssuesInCustomOffering
        },
        underWritingIssues: {
            underwritingIssues: underwritingIssues,
            blockQuote: findBlockingPoint(),
            quoteID: submissionVM.quoteID.value,
            filterUWIssuesInCustomOffering,
            job:submissionVM.baseData.jobType.value
        },
    };


    const resolvers = {
        resolveComponentMap: { questionset: QuestionSetComponent },
        resolveCallbackMap: {
            onValidate: onValidate
        }
    };

    const shouldSkipBopPage = useCallback(() => {
        const preQualQuestionSets = _.get(
            submissionVM,
            LOB_PATH[lobCode].replace(/\.children\[\d\]/, '')
        );
        if (!_.isEmpty(preQualQuestionSets)) {
            const answerValues = _.values(preQualQuestionSets[0].answers);
            return answerValues.some((value) => value !== null);
        }
        return false;
    }, [lobCode, submissionVM]);

    const hasLicenseNumberForPADriver = useCallback(() => {
        const licenseNumber = _.get(
            submissionVM,
            'lobData.personalAuto.coverables.drivers.value[0].licenseNumber'
        );

        if (config.persona === 'producer' || config.persona === 'csr') {
            return !_.isEmpty(licenseNumber);
        }
        return true;
    }, [submissionVM]);

    useEffect(() => {
        if (lobCode === 'PersonalAuto') {
            registerInitialComponentValidation(hasLicenseNumberForPADriver);
        } else if (lobCode === 'BusinessOwners') {
            registerInitialComponentValidation(shouldSkipBopPage);
        }
        if (submissionVM.lobData.homeowners.value) {
            const newQualQuestionSets = _.get(submissionVM, LOB_PATH[lobCode]);
            //   updateDateQuestionsHO(submissionVM.lobData.homeowners.preQualQuestionSets.value[0].answers);
            if(newQualQuestionSets) {
                parseDateObjects(newQualQuestionSets.answers);
            }
        }
        // execute once
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <WizardPage onNext={onNext} skipWhen={initialValidation}>
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                onValidationChange={onValidate}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={styles}
            />
        </WizardPage>
    );
}

QualificationPage.propTypes = wizardProps;
export default QualificationPage;
